import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SubriderDtlRoutingModule } from './subrider-dtl-routing.module';
import { SubriderDtlComponent } from './subrider-dtl/subrider-dtl.component';
import { SpinnerModule } from '@uiowa/spinner';
import { ModalService } from 'src/app/shared';
import { WaitlistService } from 'src/app/core';
import { FormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';


@NgModule({
  declarations: [SubriderDtlComponent],
  imports: [
    CommonModule,
    FormsModule,
    SpinnerModule,
    NgbModule,
    SubriderDtlRoutingModule
  ],
  providers: [
    ModalService,
    WaitlistService
  ]
})
export class SubriderDtlModule { }
